import { useCallback } from "react";
import { FormFieldErrors, hasErrors, useForm, validateMandatoryField } from "../../utils/form";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    IconButton,
    Radio,
    RadioGroup,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useUserInfo } from "../../utils/security";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";

const TransactionStatusDialog = ({ open, hide, onChange, data, disabled }) => {
    const { userInfo } = useUserInfo();
    const onSubmit = useCallback(
        (values) => {
            onChange?.(values);
            hide();
        },
        [hide, onChange]
    );
    const validate = useCallback((values, errors) => {
        if (values.paid === true) {
            validateMandatoryField(values.paymentDate, "paymentDate", errors);
        }
    }, []);

    const mapDataToFields = useCallback(
        ({ paymentDate, paid }) => ({
            paymentDate: paymentDate ? dayjs(paymentDate, "YYYY-MM-DD") : null,
            paid: `${paid || false}`,
        }),
        []
    );
    const mapFieldsToData = useCallback(
        ({ paymentDate, paid }) => ({
            paymentDate: paymentDate ? dayjs(paymentDate).format("YYYY-MM-DD") : undefined,
            paid: paid === "true",
        }),
        []
    );
    const { values, handleSubmit, handleChange, errors, setValues } = useForm({
        data,
        onSubmit,
        validate,
        mapDataToFields,
        mapFieldsToData,
    });

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={hide}>
            <DialogTitle>Stav transakce</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={hide}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}>
                <CloseOutlined />
            </IconButton>
            <DialogContent>
                <Box mb={2}>
                    <FormControl>
                        <FormLabel>Stav</FormLabel>
                        <RadioGroup name="paid" value={values.paid} onChange={handleChange}>
                            <FormControlLabel
                                value={false}
                                control={<Radio />}
                                label="Nezaplaceno"
                            />
                            <FormControlLabel value={true} control={<Radio />} label="Zaplaceno" />
                        </RadioGroup>
                    </FormControl>
                    {values.paid === "true" && (
                        <DatePicker
                            onChange={(paymentDate) => {
                                setValues({
                                    ...values,
                                    paymentDate,
                                });
                            }}
                            value={values.paymentDate || null}
                            label="Datum zaplacení"
                            format={userInfo.dateFormat}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    required: true,
                                    error: hasErrors(errors, "paymentDate"),
                                    margin: "normal",
                                },
                            }}
                            helperText={<FormFieldErrors errors={errors} field="paymentDate" />}
                        />
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, px: 3 }}>
                <Button onClick={hide} disabled={disabled}>
                    Storno
                </Button>
                <Button variant="contained" disabled={disabled} onClick={handleSubmit}>
                    Uložit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TransactionStatusDialog;
